module.exports = __webpack_public_path__ + "img/2.5b4fa690.png";